import React, { useEffect, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import {
  useStylesUp, useStylesHed, useStylesAuto,useStylesAutoPurch,useStylesTF, useStylesTD, useStylesBA, useStylesLbl
  , useStylesUiElemment,
  useStylesSpDial,useStylesAutoBlack,
} from '../../../../St/Reports/UseStyle';
import { useTranslation } from 'react-i18next';


export default function VatReportsOneForm(props){

  const {
    type,
    rptParams,
   onChangeData,
   onChangeAutoData,
 AutoOptions,
 typeSearch
  }=props;
  const { t } = useTranslation(["forms"]);

  const clasup = useStylesUp();
  const calsPurch = useStylesAutoPurch();
  const claslbl = useStylesLbl();
  const clasAo = useStylesAutoBlack();
  const clasTF = useStylesTF();
    return (
          <React.Fragment>
              <Grid container style={{padding:5 }} spacing={1}>

                <Grid item lg={2} md={2}  sm={4} xs={6} style={{fontWeight:"bold" ,paddingBottom:"0.5rem"}}>
                    <TextField  fullWidth variant="outlined" size="small" id="datef" 
                    label={t("date-from")}
                    className={clasTF.rootCust} 
                    InputProps={{ className:claslbl.clrBlackTxt }}
                    InputLabelProps={{className:claslbl.clrBlackLblS}}
                    type="date" format="YYYY-MM-DD"
                    name="dateFrom" value={rptParams.dateFrom} 
                    onChange={onChangeData("dateFrom")}/>
                </Grid>
                <Grid item lg={2} md={2}  sm={4} xs={6} style={{fontWeight:"bold" ,paddingBottom:"0.5rem"}}>
                    <TextField  fullWidth variant="outlined" size="small" id="datef" 
                    label={t("date-to")}
                    className={clasTF.rootCust} 
                    InputProps={{ className:claslbl.clrBlackTxt }}
                    InputLabelProps={{className:claslbl.clrBlackLblS}}
                    type="date" format="YYYY-MM-DD"
                    name="dateTo" value={rptParams.dateTo} 
                    onChange={onChangeData("dateTo")}/>
                </Grid>


                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete
                        classes={clasTF}
                        value={rptParams.branch}
                        onChange={(event, newValue) => {
                            onChangeAutoData("branch", newValue);
                        }}
                        id="controllable-states-demo"
                        size="small"
                        options={AutoOptions?.Branches}
                        style={{color:'black',fontWeight:"bold",fontSize:"1rem"}}
                        InputProps={{ className:claslbl.clrBlackTxt }}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                          }
                        renderInput={(params) => (
                            <TextField
                            id="user"
                                {...params}
                                label={t("branch")}
                                variant="outlined"
                                size="small"
                                InputLabelProps={{ className:claslbl.clrBlackLblS}}
                            />
                        )}
                    />

                </Grid>                           
               
               
                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete
                        classes={clasTF}
                        value={rptParams.typeSearch}
                        onChange={(event, newValue) => {
                            onChangeAutoData("typeSearch", newValue);
                        }}
                        id="controllable-states-demo"
                        size="small"
                        options={typeSearch}
                        style={{color:'black',fontWeight:"bold",fontSize:"1rem"}}
                        InputProps={{ className:claslbl.clrBlackTxt }}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                          }
                        renderInput={(params) => (
                            <TextField
                            id="center"
                                {...params}
                                label={t("view-by")}
                                variant="outlined"
                                size="small"
                                InputLabelProps={{ className:claslbl.clrBlackLblS}}
                            />
                        )}
                    />

                </Grid> 


            </Grid>  

          </React.Fragment>
          
    );
 
}